import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[appAutofocus]'
})
export class AutofocusDirective implements OnInit {
    constructor(private el: ElementRef) { }

    ngOnInit() {
        // Timeout gives the DOM a moment to render (useful in modals)
        setTimeout(() => {
            this.el.nativeElement.focus();
        }, 100);
    }
}
